import { useState, useEffect } from "react";
import { Link } from "react-router-dom";

const navItems = [
  { label: "Obiekty", href: "#facilities" },
  { label: "Zakwaterowanie", href: "#accommodation" },
  { label: "Dla agencji", href: "#b2b" },
  { label: "Korzyści", href: "#benefits" },
  { label: "Kontakt", href: "#contact" },
];

export default function PlayitasNav() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollTo = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? "bg-white shadow-md" : "bg-transparent"}`}>
      <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
        <div className="flex items-center gap-4">
          <Link to="/" className="flex items-center gap-2 text-xs font-bold uppercase tracking-widest text-white/70 hover:text-white transition-colors whitespace-nowrap" style={scrolled ? { color: "#CC1F1A" } : {}}>
            <i className="ri-arrow-left-line" />
            Meet Hiszpania
          </Link>
          <div className={`w-px h-8 ${scrolled ? "bg-gray-300" : "bg-white/30"}`} />
          <img src="https://www.playitas.net/img/logo.svg" alt="Playitas Resort" className="h-10 w-auto" />
        </div>

        <div className="hidden lg:flex items-center gap-1">
          {navItems.map((item) => (
            <button key={item.label} onClick={() => scrollTo(item.href)}
              className={`px-4 py-2 text-sm font-medium rounded-md transition-colors cursor-pointer whitespace-nowrap ${scrolled ? "text-gray-700 hover:text-orange-500 hover:bg-orange-50" : "text-white/90 hover:text-white hover:bg-white/10"}`}>
              {item.label}
            </button>
          ))}
        </div>

        <button onClick={() => scrollTo("#contact")}
          className="hidden lg:inline-flex items-center gap-2 px-5 py-2.5 text-sm font-bold text-white rounded-full transition-all cursor-pointer whitespace-nowrap hover:opacity-90 bg-orange-500">
          Zarejestruj się
          <i className="ri-arrow-right-line" />
        </button>
      </div>
    </nav>
  );
}
